import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { InputColumn } from "src/components/Inputs";
import { SelectSubDepartment } from "src/components/Selects";
import { useData } from "src/components/Table";
import { Edit, Insert } from "./Form";
import { ListButtonRow, ButtonDelete } from "src/components/Buttons";
import { deleteSubDepartment } from "src/services/api/admin";

const SubDepartment: React.FC<Props> = () => {
  const item = useData<SubDepartmentFormValues>();
  const [selectedId, setSelectedId] = useState<number>();

  const onDelete = () => {
    if (selectedId) {
      return deleteSubDepartment(selectedId)
        .then(({ data }) => {
          item.deleted.set(item.selected.item);
          item.selected.set(undefined);

          return Promise.resolve(data);
        })
        .catch(({ data }) => {
          return Promise.reject(data);
        });
    }

    return Promise.reject();
  };

  return (
    <Row>
      <Col sm={4}>
        <InputColumn label="Sub Departamento">
          <Row>
            <Col>
              <SelectSubDepartment
                onChange={(value: any) => {
                  setSelectedId(value);
                  item.selected.set(value);
                }}
                updatedItem={item.updated.item}
                deletedItem={item.deleted.item}
                newItem={item.created.item}
              />
            </Col>
          </Row>
        </InputColumn>
        <Row>
          <Col>
            <ListButtonRow
              buttonsLeft={
                <>
                  <Insert insertedItem={item.created.set} />
                  <Edit
                    item={item.selected.item!}
                    updatedItem={item.updated.set}
                  />
                </>
              }
              buttonsRight={
                <ButtonDelete
                  disabled={!item.selected.item}
                  onClick={onDelete}
                />
              }
              marginTop="mt-2"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SubDepartment;
